
export const ADMIN_COURS_INITIATE_AJOUTER_COURS = 'ADMIN_COURS_INITIATE_AJOUTER_COURS';
export const ADMIN_COURS_AJOUTER_COURS_START = 'ADMIN_COURS_AJOUTER_COURS_START';
export const ADMIN_COURS_AJOUTER_COURS_SUCCESS = 'ADMIN_COURS_AJOUTER_COURS_SUCCESS';
export const ADMIN_COURS_AJOUTER_COURS_FAIL = 'ADMIN_COURS_AJOUTER_COURS_FAIL';
export const ADMIN_COURS_AJOUTER_COURS_RESET = 'ADMIN_COURS_AJOUTER_COURS_RESET';